import {FeaturesEnum} from './featuresFlagEnum';
import {ProductEnum} from './productEnum';

export const NEW_BILLS_BEMOBI_FEATURE_BY_HOST = {
	[ProductEnum.HAP]: FeaturesEnum.PORTAL_FEATURE_NEW_BILLS_BEMOBI_HAP,
	[ProductEnum.CCG]: FeaturesEnum.PORTAL_FEATURE_NEW_BILLS_BEMOBI_CCG,
	[ProductEnum.CLINIPAM]: FeaturesEnum.PORTAL_FEATURE_NEW_BILLS_BEMOBI_CLINIPAM,
	[ProductEnum.GNDI_MINAS]: FeaturesEnum.PORTAL_FEATURE_NEW_BILLS_BEMOBI_NDIMINAS,
	[ProductEnum.GNDI]: FeaturesEnum.PORTAL_FEATURE_NEW_BILLS_BEMOBI_NDISP,
	[ProductEnum.NOTREDAME_SAUDE]: FeaturesEnum.PORTAL_FEATURE_NEW_BILLS_BEMOBI_NDISP,
};
